<script>
export default {
  data() {
    return {
      filters: {
        available: [
          {
            name: 'Należy do zespołu',
            query_param: 'is_staff',
            options: [
              { label: 'Tak', value: 'true' },
              { label: 'Nie', value: 'false' }
            ]
          },
          {
            name: 'Jest aktywny',
            query_param: 'is_active',
            options: [
              { label: 'Tak', value: 'true' },
              { label: 'Nie', value: 'false' }
            ]
          }
        ],
        selected: {}
      }
    }
  },
  methods: {
    parseOption(option) {
      return { label: option.name, value: option.id }
    }
  }
}
</script>
